import SkillsComponent from "../../component/skills_component";

const Skills = ({ skills }) => {
    return (
        <div className="skills">
            <div className="skills-header">
                Skills
            </div>
            <div className="badges-content-card">
                {
                    skills.map((skill, index) => (
                        <SkillsComponent key={ index } skill={ skill }/>
                    ))
                }
                
            </div>
        </div>
    )
}

export default Skills;